import { IBackendCartEntries, ICartEntry } from '@rbi-ctg/menu';
import { useFeatureFoodwareQuery } from 'generated/sanity-graphql';
import { withSimpleCache } from 'state/graphql/with-simple-cache';

const FEATURE_FOODWARE_SINGLETON_ID = 'feature-foodware-singleton';

const useFoodware = () => {
  const cachedFeatureFoodwareQuery = withSimpleCache(useFeatureFoodwareQuery);

  const { data, loading } = cachedFeatureFoodwareQuery({
    variables: {
      featureFoodwareId: FEATURE_FOODWARE_SINGLETON_ID,
    },
  });

  const isFoodware = (cartEntry: ICartEntry | IBackendCartEntries): boolean => {
    if (!cartEntry?.isExtra || !data?.FeatureFoodware?.items?.length) {
      return false;
    }

    return (
      data?.FeatureFoodware?.items.findIndex(item => {
        const isBackendCartEntry = 'lineId' in cartEntry;
        const cartEntryId = isBackendCartEntry ? cartEntry.sanityId : cartEntry._id;
        return item?._id === cartEntryId;
      }) > -1
    );
  };

  return {
    isFoodware,
    featureFoodware: data?.FeatureFoodware,
    loading,
  };
};

export default useFoodware;
